import { tablet, mobile } from "../responsive";
import styled from "styled-components";
export const StyledNewInstanceCard = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  width: 600px;
  margin-bottom: 2rem;
  ${tablet({ width: "300px" })}
  ${mobile({ width: 300 })}
  .status {
    font-size: 0.8rem;
    color: #999999;
  }

  li {
    font-size: 0.8rem;
    margin: 0.5rem 0;
    display: flex;
    column-gap: 0.3rem;
  }

  .slider {
    margin-top: 2rem;
  }

  .reset {
    font-size: 0.8rem;
    text-align: left;
    color: #999999;
    transition: all 0.2s ease-in-out;

    &:hover {
      text-decoration: underline;
      color: black;
    }
  }
  form {
    input {
      margin: 0.5 rem 0;
    }
    display: flex;
    flex-direction: column;
    row-gap: 0.5rem;

    .comment-box {
      min-height: 2rem;
    }
    .submit-btn {
      border: solid 1px black;
      border-radius: 30px;
      width: 8rem;
      margin: 1rem 0;
      padding: 0.7rem;
      cursor: pointer;
    }
  }
`;
export const StyledNewInstance = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;

  .react-datepicker-wrapper {
    width: auto;
    margin-bottom: 2rem;
  }
  p {
    font-size: 0.8rem;
    margin-bottom: 1rem;
  }
`;

export const RAGSContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  margin-top: 1rem;
`;

export const ActionWrapper = styled.div`
  padding-top: 2rem;
  width: 600px;
  .rdw-editor-wrapper {
    background-color: white;
    .rdw-editor-main {
      padding: 0.5rem;
    }
  }

  ${tablet({ width: "300px" })}
  margin-bottom: 1rem;
`;
